import type { ReduxAction } from "ee/constants/ReduxActionConstants";
import { createImmerReducer } from "utils/ReducerUtils";
import { ReduxActionTypes } from "ee/constants/ReduxActionConstants";
import type { ApplicationPagePayload } from "ee/api/ApplicationApi";
import type { ApplicationVersion } from "ee/actions/applicationActions";

interface Application {
  applicationVersion: ApplicationVersion | undefined;
  id: string;
  name: string;
  type: string;
  slug: string;
  pages: ApplicationPagePayload[];
}

interface Workspace {
  id: string;
  name: string;
  type: string;
}

export interface EditCardDataItem {
  application: Application;
  workspace: Workspace;
  latestEditedAt: string;
}

export interface HomeReduxState {
  recentlyEditData: EditCardDataItem[];
  quickAccess: any;
}

export const initialState: HomeReduxState = {
  recentlyEditData: [],
  quickAccess: [],
};

export const handlers = {
  [ReduxActionTypes.FETCH_RECENTLY_CASE_SUCCESS]: (
    state: HomeReduxState,
    action: ReduxAction<any>,
  ) => {
    state.recentlyEditData = action.payload;
  },

  [ReduxActionTypes.FETCH_QUICK_ACCESS_SUCCESS]: (
    state: HomeReduxState,
    action: ReduxAction<any>,
  ) => {
    state.quickAccess = action.payload;
  },
};

const homeReducer = createImmerReducer(initialState, handlers);

export default homeReducer;
